/* SOMNARA — interacciones propias (vanilla, sin librerías) */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Revelado al hacer scroll: un único observador compartido */
  function initRevelado() {
    var els = document.querySelectorAll('.sm-reveal, [data-sm-observa]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reducido) {
      els.forEach(function (el) { el.classList.add('sm-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('sm-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Cielo estrellado generado */
  function initEstrellas() {
    document.querySelectorAll('[data-sm-estrellas]').forEach(function (cielo) {
      if (cielo.dataset.listo) return;
      cielo.dataset.listo = '1';
      var n = parseInt(cielo.dataset.smEstrellas, 10) || 40;
      var frag = document.createDocumentFragment();
      for (var i = 0; i < n; i++) {
        var s = document.createElement('span');
        var tam = Math.random() < 0.15 ? 3 : (Math.random() < 0.5 ? 2 : 1);
        s.style.cssText = 'left:' + (Math.random() * 100).toFixed(2) + '%;top:' + (Math.random() * 100).toFixed(2) + '%;width:' + tam + 'px;height:' + tam + 'px;--t:' + (3 + Math.random() * 6).toFixed(1) + 's;--r:' + (Math.random() * 6).toFixed(1) + 's;--o:' + (0.35 + Math.random() * 0.6).toFixed(2);
        frag.appendChild(s);
      }
      cielo.appendChild(frag);
    });
  }

  /* Parallax suave del hero (solo transform) */
  function initParallax() {
    var capas = document.querySelectorAll('[data-sm-parallax]');
    if (!capas.length || reducido) return;
    var pendiente = false;
    function mover() {
      pendiente = false;
      capas.forEach(function (c) {
        if (window.innerWidth < 750) { c.style.transform = ''; return; }
        var r = c.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var f = parseFloat(c.dataset.smParallax) || 0;
        c.style.transform = 'translate3d(0,' + (-r.top * f / 100).toFixed(1) + 'px,0)';
      });
    }
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; requestAnimationFrame(mover); }
    }, { passive: true });
    mover();
  }

  /* Pasos que se iluminan en la escena fija */
  function initPasos() {
    var pasos = document.querySelectorAll('[data-sm-paso]');
    if (!pasos.length) return;
    if (!('IntersectionObserver' in window)) { pasos.forEach(function (p) { p.classList.add('sm-activo'); }); return; }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) { e.target.classList.toggle('sm-activo', e.isIntersecting); });
    }, { rootMargin: '-40% 0px -40% 0px' });
    pasos.forEach(function (p) { io.observe(p); });
  }

  /* Cifras que cuentan hacia arriba */
  function initCifras() {
    var cifras = document.querySelectorAll('[data-sm-cuenta]');
    if (!cifras.length) return;
    function formatea(v, dec) { return v.toFixed(dec).replace('.', ','); }
    function anima(el) {
      var fin = parseFloat(String(el.dataset.smCuenta).replace(',', '.'));
      if (isNaN(fin)) return;
      var dec = (String(el.dataset.smCuenta).split(/[.,]/)[1] || '').length;
      if (reducido) { el.textContent = formatea(fin, dec); return; }
      var t0 = null, dur = 1800;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var e = 1 - Math.pow(1 - p, 4);
        el.textContent = formatea(fin * e, dec);
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { cifras.forEach(anima); return; }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) { if (e.isIntersecting) { anima(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.6 });
    cifras.forEach(function (c) { io.observe(c); });
  }

  /* Línea del ritual: la altura depende de la foto */
  function initRitual() {
    document.querySelectorAll('.sm-ritual__pista').forEach(function (pista) {
      var foto = pista.querySelector('.sm-paso__foto');
      if (!foto) return;
      function ajusta() { pista.style.setProperty('--foto-alto', foto.offsetHeight + 'px'); }
      ajusta();
      window.addEventListener('resize', ajusta);
    });
  }

  /* Acordeones: solo uno abierto por grupo si se pide */
  function initAcordeones() {
    document.querySelectorAll('[data-sm-uno-abierto]').forEach(function (grupo) {
      var items = grupo.querySelectorAll('details');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* Página de producto: galería, variantes, cantidad y barra fija */
  function initProducto() {
    var raiz = document.querySelector('[data-sm-producto]');
    if (!raiz) return;

    // Galería
    var grandes = raiz.querySelectorAll('.sm-galeria__principal img');
    var minis = raiz.querySelectorAll('.sm-galeria__miniaturas button');
    var actual = 0;
    function muestra(i) {
      if (!grandes.length) return;
      actual = (i + grandes.length) % grandes.length;
      grandes.forEach(function (g, k) { g.classList.toggle('sm-activa', k === actual); });
      minis.forEach(function (m, k) { m.classList.toggle('sm-activa', k === actual); });
    }
    minis.forEach(function (m, k) { m.addEventListener('click', function () { muestra(k); }); });
    var ant = raiz.querySelector('[data-sm-anterior]');
    var sig = raiz.querySelector('[data-sm-siguiente]');
    if (ant) ant.addEventListener('click', function () { muestra(actual - 1); });
    if (sig) sig.addEventListener('click', function () { muestra(actual + 1); });
    var principal = raiz.querySelector('.sm-galeria__principal');
    if (principal) {
      var x0 = null;
      principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      principal.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) muestra(actual + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    }
    function irAMedia(mediaId) {
      if (!mediaId) return;
      grandes.forEach(function (g, k) { if (g.dataset.mediaId === String(mediaId)) muestra(k); });
    }

    // Variantes
    var input = raiz.querySelector('input[name="id"]');
    var precio = raiz.querySelectorAll('[data-sm-precio]');
    var tachado = raiz.querySelectorAll('[data-sm-tachado]');
    var ahorro = raiz.querySelector('[data-sm-ahorro]');
    var nombre = raiz.querySelector('[data-sm-variante-nombre]');
    var botones = document.querySelectorAll('[data-sm-boton-compra]');
    var txtAgotado = raiz.dataset.smAgotado || 'Agotado';
    var txtComprar = raiz.dataset.smComprar || 'Añadir al carrito';
    raiz.querySelectorAll('.sm-variante').forEach(function (v) {
      v.addEventListener('click', function () {
        raiz.querySelectorAll('.sm-variante').forEach(function (o) { o.classList.remove('sm-activa'); o.setAttribute('aria-pressed', 'false'); });
        v.classList.add('sm-activa');
        v.setAttribute('aria-pressed', 'true');
        if (input) input.value = v.dataset.id;
        precio.forEach(function (p) { p.textContent = v.dataset.precio; });
        tachado.forEach(function (t) { t.textContent = v.dataset.tachado || ''; t.hidden = !v.dataset.tachado; });
        if (ahorro) { ahorro.textContent = v.dataset.ahorro || ''; ahorro.hidden = !v.dataset.ahorro; }
        if (nombre) nombre.textContent = v.dataset.nombre;
        var disponible = v.dataset.agotada !== 'true';
        botones.forEach(function (b) {
          b.disabled = !disponible;
          var t = b.querySelector('[data-sm-boton-texto]');
          if (t) t.textContent = disponible ? txtComprar : txtAgotado;
        });
        irAMedia(v.dataset.media);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.dataset.id);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });

    // Cantidad
    var cant = raiz.querySelector('.sm-cantidad input');
    raiz.querySelectorAll('[data-sm-cant]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(cant.value, 10) || 1;
        v = Math.max(1, v + parseInt(b.dataset.smCant, 10));
        cant.value = v;
      });
    });

    // Barra fija
    var barra = document.querySelector('[data-sm-barra]');
    var form = raiz.querySelector('form[action*="/cart/add"]');
    if (barra && form && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) {
        var fuera = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
        barra.classList.toggle('sm-visible', fuera);
      });
      io.observe(form);
      var bb = barra.querySelector('[data-sm-boton-compra]');
      if (bb) bb.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }
  }

  /* Simulador interactivo del dispositivo */
  function initSimulador() {
    document.querySelectorAll('[data-sm-simulador]').forEach(function (sec) {
      if (sec.dataset.listo) return;
      sec.dataset.listo = '1';
      var escena = sec.querySelector('[data-sm-sim-escena]');
      var mando = sec.querySelector('[data-sm-sim-mando]');
      var dig = sec.querySelector('[data-sm-sim-digitos]');
      var modoTxt = sec.querySelector('[data-sm-sim-modotxt]');
      var rango = sec.querySelector('[data-sm-sim-rango]');
      var salida = sec.querySelector('[data-sm-sim-salida]');
      var nota = sec.querySelector('[data-sm-sim-nota]');
      var canvas = sec.querySelector('[data-sm-sim-onda]');
      var ctx = canvas ? canvas.getContext('2d') : null;
      var estado = { modo: 'relax', nivel: 5, on: true };

      function pinta() {
        var n = estado.nivel;
        dig.textContent = (n < 10 ? '0' : '') + n;
        modoTxt.textContent = estado.modo === 'relax' ? 'Sleep' : 'Excited';
        rango.value = n;
        salida.textContent = n;
        rango.style.setProperty('--p', ((n - 1) / 19 * 100) + '%');
        var vel = estado.modo === 'relax' ? (6 - n * 0.12) : (2.6 - n * 0.07);
        escena.style.setProperty('--vel', vel.toFixed(2) + 's');
        escena.style.setProperty('--fuerza', (0.25 + n / 20 * 0.75).toFixed(2));
        mando.classList.toggle('sm-apagado', !estado.on);
        escena.classList.toggle('sm-apagado', !estado.on);
        var msg;
        if (!estado.on) msg = sec.dataset.notaApagado;
        else if (n <= 4) msg = sec.dataset.notaBajo;
        else if (n >= 15) msg = sec.dataset.notaAlto;
        else msg = estado.modo === 'relax' ? sec.dataset.notaRelax : sec.dataset.notaActivo;
        nota.textContent = msg;
      }
      sec.querySelectorAll('[data-sm-sim-modo]').forEach(function (b) {
        b.addEventListener('click', function () {
          estado.modo = b.dataset.smSimModo; estado.on = true;
          sec.querySelectorAll('[data-sm-sim-modo]').forEach(function (o) { o.classList.toggle('sm-activa', o === b); });
          pinta();
        });
      });
      rango.addEventListener('input', function () { estado.nivel = parseInt(rango.value, 10); estado.on = true; pinta(); });
      sec.querySelector('[data-sm-sim-mas]').addEventListener('click', function () { estado.nivel = Math.min(20, estado.nivel + 1); estado.on = true; pinta(); });
      sec.querySelector('[data-sm-sim-menos]').addEventListener('click', function () { estado.nivel = Math.max(1, estado.nivel - 1); estado.on = true; pinta(); });
      sec.querySelector('[data-sm-sim-power]').addEventListener('click', function () { estado.on = !estado.on; pinta(); });
      pinta();

      // Onda en directo
      if (!ctx) return;
      var t = 0, visible = true;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(canvas);
      }
      function dibuja() {
        requestAnimationFrame(dibuja);
        if (!visible) return;
        var dpr = window.devicePixelRatio || 1;
        var w = canvas.clientWidth, h = canvas.clientHeight;
        if (canvas.width !== w * dpr) { canvas.width = w * dpr; canvas.height = h * dpr; }
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.clearRect(0, 0, w, h);
        var amp = estado.on ? (h * 0.08 + h * 0.36 * estado.nivel / 20) : 0;
        var periodo = estado.modo === 'relax' ? 150 : 62;
        var anchoPulso = estado.modo === 'relax' ? 26 : 12;
        t += reducido ? 0 : (estado.modo === 'relax' ? 0.6 : 1.6);
        ctx.lineWidth = 2;
        ctx.strokeStyle = '#3BEA7A';
        ctx.shadowColor = 'rgba(59,234,122,0.8)';
        ctx.shadowBlur = 10;
        ctx.beginPath();
        for (var x = 0; x <= w; x += 2) {
          var fase = ((x + t) % periodo) / periodo;
          var d = fase * periodo;
          var y = h / 2;
          if (d < anchoPulso) y -= Math.sin(d / anchoPulso * Math.PI) * amp;
          else if (d < anchoPulso * 2) y += Math.sin((d - anchoPulso) / anchoPulso * Math.PI) * amp * 0.45;
          if (x === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
        }
        ctx.stroke();
      }
      dibuja();
    });
  }

  /* Puntos interactivos sobre la foto */
  function initPuntos() {
    document.querySelectorAll('[data-sm-puntos]').forEach(function (sec) {
      var puntos = sec.querySelectorAll('[data-sm-punto]');
      var ventajas = sec.querySelectorAll('[data-sm-ventaja]');
      var auto = true, i = 0, temp;
      function activa(k) {
        i = k;
        puntos.forEach(function (p, j) { p.classList.toggle('sm-activa', j === k); });
        ventajas.forEach(function (v, j) { v.classList.toggle('sm-activa', j === k); });
      }
      function manual(k) { auto = false; clearInterval(temp); activa(k); }
      puntos.forEach(function (p, k) { p.addEventListener('click', function () { manual(k); }); p.addEventListener('mouseenter', function () { manual(k); }); });
      ventajas.forEach(function (v, k) { v.addEventListener('click', function () { manual(k); }); });
      if (!reducido && ventajas.length > 1) {
        temp = setInterval(function () { if (auto) activa((i + 1) % ventajas.length); }, 4000);
      }
    });
  }

  /* Comparador antes / después */
  function initComparador() {
    document.querySelectorAll('[data-sm-comp]').forEach(function (c) {
      var rango = c.querySelector('[data-sm-comp-rango]');
      var arrastrando = false;
      function pon(clientX) {
        var r = c.getBoundingClientRect();
        var p = Math.max(0, Math.min(100, (clientX - r.left) / r.width * 100));
        c.style.setProperty('--pos', p + '%');
        if (rango) rango.value = Math.round(p);
      }
      c.addEventListener('pointerdown', function (e) { arrastrando = true; pon(e.clientX); });
      window.addEventListener('pointermove', function (e) { if (arrastrando) pon(e.clientX); });
      window.addEventListener('pointerup', function () { arrastrando = false; });
      c.addEventListener('mousemove', function (e) { if (e.buttons === 0 && window.matchMedia('(hover: hover)').matches) pon(e.clientX); });
      if (rango) rango.addEventListener('input', function () { c.style.setProperty('--pos', rango.value + '%'); });
    });
  }

  function init() {
    document.documentElement.classList.remove('sm-sin-js');
    initSimulador();
    initPuntos();
    initComparador();
    initEstrellas();
    initRevelado();
    initParallax();
    initPasos();
    initCifras();
    initRitual();
    initAcordeones();
    initProducto();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // El editor de Shopify recarga secciones sueltas: reiniciamos
  document.addEventListener('shopify:section:load', function () {
    initEstrellas(); initRevelado(); initPasos(); initCifras(); initRitual(); initAcordeones();
    initSimulador(); initPuntos(); initComparador();
  });
})();
